<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '80px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="版本">
              <global-select
                @change="handleVersionChange"
                :setParams="{forecastName:queryParams.forecastName}"
                :value.sync="queryParams.versionCode"
                selectType="select"
                requestApi="/scp/salesForecast/versionCodePullDown"
                :selectItem="{ value: 'realValue', label: 'label' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="版本说明">
              <a-input :disabled="true" v-model="queryParams.versionDescription"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="事业部">
              <global-select
                :max-tag-count="1"
                :max-tag-text-length="4"
                show-search
                :value.sync="queryParams.businessUnit"
                :dropdown-match-select-width="false"
                selectType="selectFilter"
                :selectData="businessUnitList"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
              />
            </a-form-item>
          </a-col>
          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="物料编码">
                <global-select
                  :value.sync="queryParams.itemCode"
                  :dropdown-match-select-width="false"
                  selectType="selectAssembleSearch"
                  requestApi="/mes/mesDiscreteJobs/assemblyBox"
                  :selectItem="{ value: 'selectedValue', label: 'bringOutDataOne' }"
                  searchParam="itemCode" />
              </a-form-item>
            </a-col>
          </template>
          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="主型号">
                <a-input :disabled="false" v-model="queryParams.mainModel"></a-input>
              </a-form-item>
            </a-col>
          </template>
          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="物料名称">
                <a-input :disabled="false" v-model="queryParams.foldNumber"></a-input>
              </a-form-item>
            </a-col>
          </template>
          <template v-if="advanced">
            <a-col :md="6" :sm="24" >
              <a-form-item label="项目组">
                <a-select mode="multiple" :max-tag-count="1" show-search option-filter-prop="children" v-model="queryParams.projectTeamList" >
                  <a-select-option v-for="(item) in projectTeams" :key="item.lookupCode">{{ item.lookupValue }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </template>

          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="handleOnSearch" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
              <a @click="toggleAdvanced" class="ml8">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <a-button @click="handleExport" type="primary" v-hasPermi="['scp:salesForecastDetail:export']">导出</a-button>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <ls-api-table
          @successCallBack="successCallBack"
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="rowKey"
          :scroll="{ fixScreen: true, x: 1300 }"
        >
          <span slot="operation" slot-scope="{ record,$index }">
            <a v-if="!isEdit || currentId !== record.flag" @click="handleEdit(record,$index)" v-hasPermi="['scp:salesForecastDetail:edit']">编辑</a>
            <a v-if="!isEdit || currentId !== record.flag" class="ml10" @click="handleDeleteAlert(typeList, record)" v-hasPermi="['scp:salesForecastDetail:remove']">删除</a>
            <a v-if="isEdit && currentId === record.flag" @click="handleSave(record)">保存</a>
            <a v-if="isEdit && currentId === record.flag" @click="handleCancel(record)" class="ml10">取消</a>
          </span>
          <!-- 平均活动价 -->
          <template slot="averageActivityPrice" slot-scope="{ record }">
            <span v-if="!isEdit || currentId !== record.flag">{{ record.averageActivityPrice }}</span>
            <a-input-number :min="0" v-if="isEdit && currentId === record.flag" v-model="record.averageActivityPrice" size="small" />
          </template>
          <!-- 版本说明 -->
          <template slot="versionDescription" slot-scope="{ record }">
            <span v-if="!isEdit || currentId !== record.flag">{{ record.versionDescription }}</span>
            <a-input v-if="isEdit && currentId === record.flag" v-model="record.versionDescription" size="small" />
          </template>
          <!-- 物料编码 -->
          <template slot="itemCode" slot-scope="{ record }">
            <span v-if="!isEdit || currentId !== record.flag">{{ record.itemCode }}</span>
            <a-input v-if="isEdit && currentId === record.flag" v-model="record.itemCode" size="small" />
          </template>

          <!-- 月份 -->
          <template slot="month" slot-scope="{ record, column }">
            <span v-if="!isEdit || currentId !== record.flag">{{ record[column.dataIndex] }}</span>
            <a-input-number @change="checkNum" :min="0" v-if="isEdit && currentId === record.flag" v-model="record[column.dataIndex]" size="small" />
            <!-- <a-button @click="handlerTestClick(record, column)"> 测试</a-button>  @change="handleInputChange(record,column.dataIndex)"-->
          </template>

          <template slot="isStopFlag" slot-scope="{ record }">
            <span >{{ record.isStopFlag === 'Y' ? '是' : '否' }}</span>
          </template>

          <!-- <div
            v-for="item in monthColumns1"
            :slot="item.dataIndex"
            slot-scope="{record}"
            :key="item.dataIndex"
          >
            <a-input v-model="record.versionCode"></a-input>
          </div> -->
        </ls-api-table>
      </div>
    </template>
  </ls-table-layout>
</template>

  <script>
  import { apiSalesForecastDetail, apiDeleteSalesForecastDetail, apiUpdateSalesForecastDetail } from '@/api/scp/salesForecast/salesForecastWorkDesk'
  import { generateLsTableResData } from '@/utils/util.js';
  export default {
    // eslint-disable-next-line
    name: 'detail',
    components: {

    },
    data () {
      return {
        businessUnitList: [],
        projectTeams: [], // 项目组
        monthColumns1: [
          {
            title: '版本',
            width: 140,
            fixed: 'left',
            dataIndex: 'month0',
            ellipsis: true,
            align: 'center'
          },
          {
            title: '版本说明',
            fixed: 'left',
            dataIndex: 'month1',
            scopedSlots: { customRender: 'versionDescription' },
            width: 140,
            align: 'center'
          }
        ],
        monthColumns: [],
        isSetTitle: false,
        // 表格配置
        tableProps: {
          requestApi: generateLsTableResData(apiSalesForecastDetail, true),
          pageCurrent: true
        },
        isEdit: false,
        currentId: "",
        // 控制搜索展开
        advanced: true,
        // 查询参数
        queryParams: {
          projectTeamList: undefined,
          mainModel: undefined,
          itemCode: undefined,
          foldNumber: undefined,
          businessUnit: undefined,
          // 预测名称
          forecastName: undefined,
           // 版本
          versionCode: undefined,
          startMonth: '',
          versionDescription: ''
        },
        // 表格多选
        selectedRowKeys: [],
        selectedRows: [],
        // 状态快码
        statusOptions: [
          {
            dictLabel: "有效",
            dictValue: "Y"
          },
          {
            dictLabel: "无效",
            dictValue: "N"
          }
        ],
        baseUomFlagOptions: [
          {
            dictLabel: "是",
            dictValue: "Y"
          },
          {
            dictLabel: "否",
            dictValue: "N"
          }
        ],
        // 表格字段
        columnsNative: [
          // {
          //   title: '版本',
          //   width: 140,
          //   fixed: 'left',
          //   dataIndex: 'versionCode',
          //   ellipsis: true,
          //   align: 'center'
          // },
          // {
          //   title: '版本说明',
          //   fixed: 'left',
          //   ellipsis: true,
          //   dataIndex: 'versionDescription',
          //   width: 140,
          //   align: 'center'
          // },
          {
            title: '事业部',
            fixed: 'left',
            dataIndex: 'scpBusinessUnit',
            width: 120,
            align: 'center'
          },
          {
            title: '物料编码',
            fixed: 'left',
            dataIndex: 'itemCode',
            ellipsis: true,
            width: 150,
            align: 'center'
          },
          {
            title: '规格描述',
            dataIndex: 'specification',
            ellipsis: true,
            width: 240,
            align: 'left'
          },
          {
            title: '项目组',
            dataIndex: 'projectTeam',
            width: 100,
            align: 'center'
          },
          {
            title: '下单类别',
            width: 180,
            dataIndex: 'orderType',
            align: 'center'
          },
          {
            title: '销售类目',
            dataIndex: 'salesCategory',
            width: 180,
            align: 'center'
          },
          {
            title: '主型号',
            width: 180,
            dataIndex: 'mainModel',
            align: 'center'
          },
          {
            title: '物料名称',
            width: 180,
            dataIndex: 'foldNumber',
            align: 'center'
          },
          {
            title: '是否停产',
            scopedSlots: { customRender: 'isStopFlag' },
            width: 100,
            dataIndex: 'isStopFlag',
            align: 'center'
          },
          {
            title: '平均活动价',
            scopedSlots: { customRender: 'averageActivityPrice' },
            width: 180,
            dataIndex: 'averageActivityPrice',
            align: 'center'
          },
          {
            title: '锁定成本',
            width: 180,
            dataIndex: 'lockedCost',
            align: 'center'
          },
            {
            title: '操作',
            width: 140,
            fixed: 'right',
            align: 'center',
            dataIndex: 'operation',
            scopedSlots: { customRender: 'operation' }
            }
        ],
        columns: [],
        unitOfMeasureList: [],
        unitOfMeasureListNew: []
      }
    },
    created () {
      this.queryParams.forecastName = this.$route.params.forecastName;
      this.queryParams.versionCode = this.$route.params.versionCode;
      this.queryParams.versionDescription = this.$route.params.versionDescription;
      this.columns = this.columnsNative
      const lookupQueryProjectTeamParams = {
            lookupType: 'SCP_PROJECT_TEAM',
            current: 1,
            pageSize: 100
        }
        this.getLookupListData(lookupQueryProjectTeamParams).then().then(response => {
        this.projectTeams = response.rows
        })
        this.getLookupList('SCP_BUSINESS_UNIT', 'businessUnitList');
    },
    mounted () {
      this.onSearch()
    },
    methods: {
      checkNum (val) {
        var number = +val; // 使用一元加(+)运算符将字符串转换为数字
        if (!isNaN(number)) { // 判断转换后的结果是否是数字
          if (number < 0) {
            this.$message.error('输入的数字不能小于0')
          }
        }
        if (val.includes("-")) {
          this.$message.error('输入的数字不能小于0')
        }
      },
      getLookupList (type, arr) {
          const lookupQueryParams = {
            lookupType: type,
            current: 1,
            pageSize: 100
          }
          this.getLookupListData(lookupQueryParams).then().then(response => {
            this[arr] = response.rows
            if (arr === 'businessUnitList') {
                this[arr] = this[arr].filter(item => item.attribute1 === null); // 只显示attribute1为""的
              }
          })
      },
      handleOnSearch () {
        this.isSetTitle = false
        this.onSearch()
      },
      handleInputChange (record, dataIndex) {
        // debugger
      },
      successCallBack (records) {
          // 遍历行数据
        for (let i = 0; i < records.length; i++) {
          const record = records[i];
          const rowKey = records[i].id + records[i].flag + i;
          const detailVoList = records[i].detailVoList
          this.monthColumns = []
            for (let i = 0; i < detailVoList.length; i++) {
              if (!self.isSetTitle) {
                  const title = detailVoList[i].month
                  this.monthColumns.push({
                    title: title,
                    dataIndex: `month${i}`,
                    width: 120,
                    align: 'center',
                    scopedSlots: { customRender: `month` }
                  })
               }
               // record[`month${i}`] = detailVoList[i].salesForecast
               const propertyName = `month${i}`;
                const propertyValue = detailVoList[i].salesForecast;
                this.$set(record, propertyName, propertyValue);
                this.$set(record, 'rowKey', rowKey);
          }
          if (!this.isSetTitle) { // 把数据插入到指定位置
            // 使用扩展运算符
            const columnsCopy = [...this.columnsNative];
            columnsCopy.splice(9, 0, ...this.monthColumns);
            this.columns = columnsCopy;
          }
          this.isSetTitle = true
        }
      },
      handleDeleteAlert (tableList, record) {
        const self = this
        this.$confirm({
        title: '警告',
        content: `真的要删除该项的数据项吗?`,
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          self.handleDelete(tableList, record)
        }
      })
      },
      handleDelete (tableList, record) {
        const param = {
          itemId: record.itemId,
          versionCode: record.versionCode,
          lookupCode: record.lookupCode
        }
        apiDeleteSalesForecastDetail(param).then(response => {
        if (response.code === 200) {
          this.$message.success('删除成功')
          this.onSearch()
        } else {
          this.$message.error(response.msg)
        }
      })
      },
      handleOperation (text, record) {
        this.$router.push({ path: `/salesForecast/detail/` })
      },
      handleNameChange (val, selectList) {
        const filteredItem = selectList.filter(item => item.realValue === val);
        this.queryParams.startMonth = filteredItem[0].bringOutDataOne
      },
      handleVersionChange (val, selectList) {
        if (val) {
          const filteredItem = selectList.filter(item => item.realValue === val);
          this.queryParams.versionDescription = filteredItem[0].bringOutDataOne
        }
      },
      blur (record) {
        if (!record.conversionRate || Number(record.conversionRate) <= 0) {
          this.$message.warning('折换不能为空且需大于0')
        } else {
          record.conversionRateInverse = this.$countBackwards(Number(record.conversionRate))
        }
      },
      statusOnChange (record) {
        record.status = record.status === 'Y' ? 'N' : 'Y'
      },
      // 导入导出excel
      /** 导出按钮操作 */
      handleExport () {
        this.download('scp/salesForecastDetail/export', {
          ...this.queryParams
        }, `销售预测明细_${new Date().getTime()}.xlsx`)
      },
      // 编辑
      handleEdit (record, index) {
        if (this.currentId && record.flag !== this.currentId && this.isEdit) {
          this.$message.warning('请保存上次编辑的数据')
          return;
        }
        this.isEdit = true;
        this.currentId = record.flag;
      },
      // 编辑-保存
      handleSave (record) {
         let isNoEdit = false
         let title = ''
        this.monthColumns.forEach(element => {
         const dataIndex = element.dataIndex
         if (record[dataIndex] === '' || record[dataIndex] === undefined || record[dataIndex] === null) {
          isNoEdit = true
          title = title + element.title + ','
         }
        });
        if (record['averageActivityPrice'] === '' || record['averageActivityPrice'] === undefined || record['averageActivityPrice'] === null) {
          isNoEdit = true
          title = title + '平均活动价' + ','
         }
        if (isNoEdit) {
          this.$message.error(title + '列为空，保存失败')
          return
        }
      const recordCopy = JSON.parse(JSON.stringify(record));
      const detailVoList = recordCopy.detailVoList
      for (let i = 0; i < detailVoList.length; i++) {
         const detailVoItem = detailVoList[i]
         detailVoItem.salesForecast = recordCopy[`month${i}`]
      }
      apiUpdateSalesForecastDetail(recordCopy).then(response => {
        if (response.code === 200) {
          this.$message.success('更新成功')
          this.onSearch()
        } else {
          this.$message.error(response.msg)
        }
      })
      },
      // 取消
      handleCancel (record) {
        this.isEdit = false
        this.onSearch()
      },
      // 新增/修改框事件
      handleOk () {
        this.onSearch()
      },
      // 表单搜索
      onSearch () {
        this.isEdit = false
        this.$refs.dataTable.searchParams = this.queryParams;
        this.$refs.dataTable.getData();
      },
      /** 重置按钮操作 */
      resetQuery () {
        this.isSetTitle = false
        this.queryParams = {
          ...this.queryParams,
          uomClassList: undefined,
          unitOfMeasureList: undefined,
          baseUomList: undefined,
          status: undefined,
          mainModel: undefined,
          itemCode: undefined,
          foldNumber: undefined,
          businessUnit: undefined,
          // 预测名称
          projectTeamList: undefined,
           // 版本
        //  versionCode: undefined,
          startMonth: ''
        //  versionDescription: ''
        }
        this.onSearch()
      },
      // 搜索框展开、收起
      toggleAdvanced () {
        this.advanced = !this.advanced
      }
    }
  }
  </script>

  <style scoped lang="less">
  .ml10{
    margin-left: 10px;
  }
  </style>
